import { ORDER_STATES, ROUTES } from "../constants";

export const getOrder = async (
  baseUrl: string,
  token: string,
  orderId: string,
  onChargeSuccess: () => void,
  onFailed: () => void,
  onError: (error: any) => void
) => {
  try {
    const response = await fetch(
      `${baseUrl}/${ROUTES.STORE_ORDERS}/${orderId}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (!response.ok) {
      throw new Error("Network response was not ok");
    }

    const data = await response.json();

    if (data.state === ORDER_STATES.CHARGE_SUCCEED) {
      onChargeSuccess?.();
    } else if ((data.state as string).toLowerCase().includes("failed")) {
      onFailed?.();
    }
  } catch (error) {
    onError?.(error);
  }
};
